import { gsap } from 'gsap'

class Animation {
	constructor(el) {
		this.el = el
		this.param = {
			delay: this.el.getAttribute('data-delay') ?? 0
		}
		if (window.innerWidth < 670) {
			this.param.duration = this.el.getAttribute('data-duration') ?? 300
			this.param.offset = this.el.getAttribute('data-mobile-offset') ?? 100
		} else {
			this.param.offset = this.el.getAttribute('data-offset') ?? 100
			this.param.duration = this.el.getAttribute('data-duration') ?? 300
		}
	}

	fadeIn() {
		gsap.to(this.el, {
			opacity: 1,
			delay: this.param.delay / 1000,
			duration: this.param.duration / 1000
		})
	}

	slideTop() {
		gsap
			.to(this.el, {
				y: '0',
				opacity: 1,
				delay: this.param.delay / 1000,
				duration: this.param.duration / 1000
			})
	}

	slideBottom() {
		gsap
			.to(this.el, {
				y: '0',
				opacity: 1,
				delay: this.param.delay / 1000,
				duration: this.param.duration / 1000
			})
	}

	scale() {
		gsap.to(this.el, {
			scale: 1,
			opacity: 1,
			delay: this.param.delay / 1000,
			duration: this.param.duration / 1000
		})
	}
}

class ScrollAnimation extends Animation {
	init() {
		window.addEventListener('scroll', () => this.isVisible())

		document.addEventListener('DOMContentLoaded', () => this.isVisible())
	}

	isVisible() {
		this.elTop = this.el.getBoundingClientRect().top
		if (this.elTop < window.innerHeight - this.param.offset && !this.el.classList.contains('animated')) {
			this.start()
		}
	}

	start() {
		this.el.classList.add('animated')

		if (this.el.classList.contains('js-animation-slideTop')) {
			this.slideTop()
		}

		if (this.el.classList.contains('js-animation-slideBottom')) {
			this.slideBottom()
		}

		if (this.el.classList.contains('js-animation-fadeIn')) {
			this.fadeIn()
		}

		if (this.el.classList.contains('js-animation-scale')) {
			this.scale()
		}
	}
}

const els = document.querySelectorAll('.js-animation')
if (els.length) {
	els.forEach(el => {
		if (window.innerWidth > 991 || el.classList.contains('js-animation-mobile')) {
			const scrollAnimation = new ScrollAnimation(el)
			scrollAnimation.init()
		}
	})
}
